import * as Yup from 'yup';

export const CakeFormShape = Yup.object().shape({
    name: Yup.string().required("Please enter cake name").min(1, "Must be at least 1 character long"),
    comment: Yup.string().required("Please enter a cake comment").min(5, "Comment must be at least 5 characters long").max(200, "Comment cannot be longer than 500 characters"),
    imageUrl: Yup.string().required("Please enter an image URL"),
    yumFactor: Yup.number().required("Please select a Yum Factor Score").min(1).max(5)
});